import { createBrowserHistory } from 'history'

// Manually create the history object so we can access outside the Router e.g. in modals
const history = createBrowserHistory()

// keep track of how deep the history stack is under current SPA runtime
let spaHistoryStackLength = 0

history.listen((_location, action) => {
  switch (action) {
    case 'PUSH':
      spaHistoryStackLength++
      break
    case 'POP':
      spaHistoryStackLength--
      break
    default:
      break
  }
})

export default history

export const getSpaHistoryStackLength = () => spaHistoryStackLength
